import {
    type TradeInAemUtilsActions,
    TRADE_IN_AEM_SET_EHUB_FAILED,
    TRADE_IN_AEM_SET_EHUB_LATEST_RESPONSE,
    TRADE_IN_AEM_SET_EHUB_SUBMITTING,
    TRADE_IN_AEM_SET_PARENT_COMPONENT,
    TRADE_IN_AEM_SET_SHOW_IN_MODAL,
    TRADE_IN_AEM_SET_USE_TEST_DATA,
    TRADE_IN_AEM_SET_VERSION,
} from "../actions/TradeInAemUtilsActions";
import type { TradeInAemEHubPayload } from "../../utils/types";
import { type TradeInAemIntegratedParentComponentType, TradeInAemVersion } from "../../utils/constants";
import type { FormInfoResponseType } from "../../../common-deprecated/utils/contactFormUtils";

export type TradeInAemUtilsReducerType = {
    version: TradeInAemVersion;
    parentComponent: TradeInAemIntegratedParentComponentType | null; // The component in which the Trade-in is integrated. (Only filled in when trade-in is used integrated)
    eHub: {
        failed: boolean;
        submitting: boolean;
        latestPayload: TradeInAemEHubPayload | null;
        latestResponse: FormInfoResponseType | null;
    };
    showStandaloneModal: boolean; // This is used to render the *standalone* tradein in a modal. Do not use for integrated trade-in purposes.
    useTestData: boolean; // This is used to prefill the content (such as forms) with test data.
};

const initialState: TradeInAemUtilsReducerType = {
    version: TradeInAemVersion.Standalone,
    parentComponent: null,
    eHub: { failed: false, submitting: false, latestPayload: null, latestResponse: null },
    showStandaloneModal: false,
    useTestData: false,
};

export const TradeInAemUtilsReducer = (
    state: TradeInAemUtilsReducerType = initialState,
    action: TradeInAemUtilsActions,
): TradeInAemUtilsReducerType => {
    switch (action.type) {
        case TRADE_IN_AEM_SET_EHUB_FAILED: {
            return { ...state, eHub: { ...state.eHub, failed: action.failed } };
        }

        case TRADE_IN_AEM_SET_EHUB_SUBMITTING: {
            const { submitting, latestPayload } = action;
            return { ...state, eHub: { ...state.eHub, submitting, latestPayload } };
        }

        case TRADE_IN_AEM_SET_EHUB_LATEST_RESPONSE: {
            const { latestResponse } = action;
            return { ...state, eHub: { ...state.eHub, latestResponse } };
        }

        case TRADE_IN_AEM_SET_VERSION: {
            return { ...state, version: action.version };
        }

        case TRADE_IN_AEM_SET_PARENT_COMPONENT: {
            return { ...state, parentComponent: action.parentComponent };
        }

        case TRADE_IN_AEM_SET_SHOW_IN_MODAL: {
            return { ...state, showStandaloneModal: action.show };
        }

        case TRADE_IN_AEM_SET_USE_TEST_DATA: {
            return { ...state, useTestData: action.useTestData };
        }

        default:
            return state;
    }
};
